var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['section-list', ("section-list_" + (_vm.project))]
  }, _vm._l(_vm.list, function (data, index) {
    return _c('GGSection', {
      key: index,
      staticClass: "section-list__el",
      attrs: {
        "data": data,
        "project": _vm.project,
        "user-cart": _vm.userCart,
        "meta": _vm.meta
      },
      on: {
        "cart-add": function ($event) {
          return _vm.$emit('cart-add', $event);
        },
        "cart-remove": function ($event) {
          return _vm.$emit('cart-remove', $event);
        },
        "auth-needed": function ($event) {
          return _vm.$emit('auth-needed');
        }
      }
    });
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }